import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';
import * as setInfo from './apiSetInfo';
import * as lookups from './lookups';
import * as AllMutates from './AllMutates';

export function updateMpiWorkItem(id, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
       dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateMpiWorkItemPage(id, key, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
        dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function sendMpiWorkItem(id, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
        dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function addMpiWorkItem(data, errorType) {
    return dispatch => Api.postData('mpi_work_items/', data).then((resp) => {
        dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
        const body = resp?.data;
        const record = body?.data || body;
        return record?.id;
    }).catch(ex => Api.handleApiError(ex, errorType));
}

// Creates (or replaces) the PDF report for one custom form. The API upserts one
// report per (vehicle, custom_form_id, report_type) and returns it, so the
// active vehicle's mpi_reports are updated in place instead of refetched.
// send_sftp is always sent explicitly: when omitted the API falls back to the
// form's setting, which would ignore an unchecked "send" box.
// Resolves { report } on success or { error } with a message to show.
export function createMpiReportPdf(vehicle_id, custom_form_id, { sendSftp = false, reportType } = {}) {
	const data = {
		vehicle_id,
		custom_form_id,
		send_sftp: !!sendSftp,
	};
	if (reportType) data.report_type = reportType;

	return (dispatch, getState) => Api.postData('mpi_reports/', data).then((resp) => {
		const report = resp?.data?.data;
		if (!report) return { error: 'Failed to create PDF' };

		const active_vehicle = getState().settings_refresh.active_vehicle || {};
		if (active_vehicle.id === vehicle_id) {
			const others = (active_vehicle.mpi_reports || []).filter(r => r.id !== report.id);
			dispatch(setInfo.setActiveVehicle({ active_vehicle: { ...active_vehicle, mpi_reports: [report, ...others] } }));
		}
		return { report };
	}).catch(ex => ({
		error: ex?.response?.data?.error || ex?.response?.data?.detail || 'Failed to create PDF',
	}));
}

export function deleteMpiWorkItem(id, errorType) {
    return dispatch => Api.delete(`mpi_work_items/${id}`).then(() => dispatch(getInfo.processDepartments())).catch(ex => Api.handleApiError(ex, errorType));
}



export function updateUviItem(id, data, errorType) {
    return (dispatch, getState) => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
       dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateMpiItemRaw(id, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
    }).catch(ex => Api.handleApiError(ex, errorType));
}
